import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function NotificationModal({
  isOpened,
  handleClose,
  titleRenderer,
  descriptionRenderer,
}) {
  return (
      <Dialog
        open={isOpened}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="dialog-modal"
      >
        <DialogTitle id="responsive-dialog-title">
          {titleRenderer()}
        </DialogTitle>
        <DialogContent>
          {descriptionRenderer()}
        </DialogContent>
        {handleClose && (
          <DialogActions>
            <Button variant="contained" className='notification-modal-close' onClick={handleClose}>
              Close
            </Button>
          </DialogActions>
        )}
      </Dialog>
  );
}